import { useParams } from 'react-router-dom'
import Select from 'react-select'

import { getRequest, postRequest } from '../../../../services/base'
import LinkWithStatus from '../../../common/LinkWithStatus'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import { useContext, useState } from 'react'
import { NavContext } from '../../../../context/global_context'
import { Sad } from '@styled-icons/boxicons-solid'

const DtcValidationRunner = ({ checkValidationFetchingProgress }) => {
  const { vehicle } = useParams()
  const [versionsData, setVersionsData] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [dataError, setDataError] = useState(null)
  const [state, dispatch] = useContext(NavContext)

  const getTracerVersions = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: `Loading Versions...`,
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/dtc_validation/tracer-data-version/${vehicle}/`
    )
    if (!res?.data?.data_version || !res?.data?.app_version) {
      setDataError(true)
    } else {
      setVersionsData(res.data)
    }

    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const startValidationProcess = async () => {
    if (
      window.confirm(
        `Are you sure want to start process for given data version`
      ) === true
    ) {
      dispatch({
        type: 'loader',
        data: {
          caption: `We are starting process...`,
          showLoader: true,
        },
        notification: {},
      })

      let payload = {
        app_version: versionsData.app_version,
        data_version: versionsData.data_version,
      }
      let res = await postRequest(
        `/api/dtc_validation/validation/run/${vehicle}/`,
        payload
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res?.msg,
          },
        })
        checkValidationFetchingProgress()
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  return (
    <>
      <LinkWithStatus
        href={`/administration/dtc_validation/tracer-data-version`}
        className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
        title="Run Validation"
        onClickFunc={() => {
          getTracerVersions()
          setShowModal(true)
        }}
      />

      <Modal
        onClose={() => {
          setShowModal(false)
        }}
        show={showModal}
      >
        <ModalHeader className={'text-white'}>
          Tracer Version and Data Version
        </ModalHeader>
        <ModalBody>
          {dataError ? (
            <div className="text-center text-white">
              <Sad size="3rem" color="white" />
              <div className="">
                Version is not availble, Please Select another make model
              </div>
            </div>
          ) : (
            <div
              className="flex items-center justify-center"
              style={{ height: '35vh' }}
            >
              <div>
                <div className="text-center text-white">
                  <div className="py-1">
                    App Version : {versionsData.app_version}
                  </div>
                  <div className="py-1">
                    Data Version : {versionsData.data_version}
                  </div>
                </div>

                <div className="flex justify-center py-5">
                  <LinkWithStatus
                    href={`/administration/dtc_validation/tracer-data-version`}
                    className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
                    title="Start Process"
                    onClickFunc={() => {
                      startValidationProcess()
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  )
}

export default DtcValidationRunner
